import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-succescreate-dialog',
  templateUrl: './succescreate-dialog.component.html',
  styleUrls: ['./succescreate-dialog.component.css'],
})
export class SuccescreateDialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
